<template>
  <div class="main-page">
    <div class='top-menu'>
      <div class='logo'><img class="float-left" src="/image/logo.png"><div class="float-left" >MEGA - MES</div></div>
      <div class='user-info'  @click='onMyPage'><img :src='userImage'></div>
      <div class='user-name'>{{userInfo.userName}}</div>
      <div class="log-out">
        <dx-button
          icon='pinleft'
          style="font-size=0.9rem;height:30px;margin-top:2px;background-color:#ff8711"
          text="로그아웃"
          type="default"
          styling-mode="contained"
          :focus-state-enabled="false"
          @click="onLogout($event)"
        />
      </div>
      <TopMenuHComponent v-if='topMenu' :menuList='topMenu' ref='topMenuComponent'></TopMenuHComponent>
    </div>
    <router-view/>
  </div>
</template>

<script>

import ConstDef from '../share/ConstDef'
// import { DxSelectBox, DxCheckBox, DxTextBox, DxDateBox, DxButton } from 'devextreme-vue'
import { DxButton } from 'devextreme-vue'
import TopMenuHComponent from '../share/component/TopMenuHComponent'
import FindAllTopMenuProc from '../share/service/FindAllTopMenuProc'
// import AppLib from '../share/AppLib'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      topMenuHeight: null,
      topMenu: null,
      userInfo: null,
      userImage: '/image/user-circle.png'
    }
  },
  components: {
    DxButton,
    TopMenuHComponent
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.init()
  },

  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  updated () {
    this.$Q('.sub-tab-wrap').css('width', (window.innerWidth - 80) + 'px')
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    async init () {
      /*
      this.isLoading = true
      await LoginByUserIdAndPasswdProc.SendParamModelToken(this.userInfo.token)
        .then((data) => {
          if (data.result !== ConstDef.SUCCESS) {
            this.$snotify.error('로그인 정보가 정확하지 않습니다.')
          } else {
            this.isLoading = false
          }
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })

      if (this.isLoading === true) {
        this.isLoading = false
        this.$router.push('/')
        return
      }
      */
      if (this.userInfo.userImage !== null) {
        this.userImage = ConstDef.apiUrl + '/imgLoadAll?file=' + this.userInfo.userImage
      }
      let baseData = this.$store.getters.getBaseData
      if (baseData === null) {
        const findTopMenu = FindAllTopMenuProc.SendParamModel()
        const sysParam = this.$_sp.runNoEncodeFindProc('spFindAllSysParamByNoSql', {})
        const baseCode = this.$_sp.runNoEncodeFindSqlProc('공통코드', null)
        const company = this.$_sp.runNoEncodeFindSqlProc('거래처정보', null)
        const carType = this.$_sp.runNoEncodeFindSqlProc('고객사생산품목', null)
        const raw = this.$_sp.runNoEncodeFindProc('spFindAllRawMeterialLookup', {})
        const topMenuTab = this.$_sp.runNoEncodeFindProc('spFindAllTopMenuForTabName', {})
        axios.all([findTopMenu, baseCode, sysParam, carType, raw, company, topMenuTab])
          .then(axios.spread((...reponse) => {
            if (reponse[0].result === ConstDef.SUCCESS) {
              this.topMenu = FindAllTopMenuProc.MakeModel(reponse[0], this.$store)
              this.$store.commit('saveBaseData', this.$_sp.MakeModel(reponse[1]))
              const sysParam = this.$_sp.MakeModel(reponse[2])
              this.$store.commit('saveSysParam', sysParam)
              console.log(this.$_.findWhere(sysParam, { key: ConstDef.SYS_USER_PERMISSION_KEY }).value)
              ConstDef.USER_PERMISSION = JSON.parse(this.$_.findWhere(sysParam, { key: ConstDef.SYS_USER_PERMISSION_KEY }).value)

              const ENCODE_BASE64 = this.$_.findWhere(sysParam, { key: 'QR_BASE64_ENCODE' }).value
              console.log(ENCODE_BASE64)
              if (ENCODE_BASE64 === 'true') {
                ConstDef.ENCODE_BASE64 = true
              } else {
                ConstDef.ENCODE_BASE64 = false
              }
              console.log('ConstDef.ENCODE_BASE64=', ConstDef.ENCODE_BASE64)
              this.$store.commit('saveCarType', this.$_.sortBy(this.$_sp.MakeModel(reponse[3]), '모델명'))
              this.$store.commit('saveRawMeterial', this.$_sp.MakeModel(reponse[4]))
              this.$store.commit('saveCompany', this.$_.sortBy(this.$_sp.MakeModel(reponse[5]), '거래처명'))
              this.$store.commit('saveTopMenuTab', this.$_sp.MakeModel(reponse[6]))
            }
          }))
      } else {
        FindAllTopMenuProc.SendParamModel()
          .then((data) => {
            this.isLoading = false
            if (data.result === ConstDef.SUCCESS) {
              this.topMenu = FindAllTopMenuProc.MakeModel(data, this.$store)
              // console.log(this.topMenu)
            /*
            if (this.$route.query.url !== undefined) {
              this.$router.push(this.$route.query.url)
            } else if (this.$route.path === '/main') {
              this.$router.push(this.gotoDefaultPage() + `?update=${AppLib.getToday()}`)
            }
            */
            }
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    onResize (e) {
      this.$Q('.sub-tab-wrap').css('width', (window.innerWidth - 80) + 'px')
      this.$Q('.sub-content').css('height', (window.innerHeight - 50) + 'px')
    },
    gotoDefaultPage () {
      let permission = this.$store.getters.getUserInfo.permission
      console.log(permission)
      for (let i = 0; i < this.topMenu.length; i++) {
        for (let j = 0; j < this.topMenu[i].subMenu.length; j++) {
          if (this.topMenu[i].subMenu[j].permission & permission) {
            console.log(this.topMenu[i].subMenu[j].url)
            return this.topMenu[i].subMenu[j].url
          }
        }
      }
    },
    onLogout (e) {
      this.userInfo = this.$store.getters.getUserInfo
      this.$router.push(`/logout/${this.userInfo.userId}`)
      /*
      let param = [
        {
          accessDate: AppLib.getNow(),
          menuName: '로그아웃',
          userId: this.userInfo.userId,
          userName: this.userInfo.userName,
          menuUrl: ''
        }
      ]
      console.log(this.userInfo)

      this.$_sp.runInsertSqlProc('PAGE_ACCESS_HIS', null,  param)
        .then((data) => {
          this.$router.push('/logout')
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/logout')
        })
      */
    },
    onHome () {
      let current = this.$route.path
      let home = this.gotoDefaultPage()
      if (current !== home) {
        this.$router.push(this.gotoDefaultPage())
        this.$refs.topMenuComponent.selectSubMenu()
      }
      /*
      // console.log(this.$store.getters.getUserInfo)
      if (this.$store.getters.getUserInfo.permission === ConstDef.BILL_MANAGER) {
        this.$router.push('/main/dailyBilling')
      } else if (this.$store.getters.getUserInfo.permission >= ConstDef.GEN_MANAGER) {
        if (current.indexOf('/main/callCenter/avgCallLine') >= 0) {
          return
        }
        this.$router.push('/main/callCenter/avgCallLine')
      } else {
        if (current.indexOf('/main/summary') >= 0) {
          return
        }
        this.$router.push('/main/summary')
      }
      */
    },
    onMyPage () {
      // console.log(this.$route)
      this.$router.push(`/myPage?beforeUrl=${this.$route.path}`)
    }
  }
}

</script>

<style lang="scss">
.main-page{
  z-index: 1000;
  .top-menu{
    z-index: 1000;
    position: fixed;
    top:0;
    left:0;
    height:70px;
    width:100%;
    background-color: #38a7d2;
    .logo {
      margin-top: 0px;
      margin-left: 6px;
      width:150px;
      text-decoration: none;
      display: block;
      div{
        margin-top:4px;
        font-size:1.4rem;
        font-weight: 700;
        color: rgb(233, 233, 233);
      }
      span{
        font-weight: 700;
        font-size:1.4rem;
        color:rgb(222,76,80);
      }
    }
    .user-info {
      position:absolute;
      right:190px;
      color:white;
      top:1px;
      border-radius: 50%;
      height:32px;
      width:32px;
      overflow: hidden;
      img{
        width:100%;
      }
    }
    .user-name {
      position:absolute;
      right:100px;
      width:85px;
      color:white;
      top:8px;
      font-weight: bold;
      overflow: hidden;
      text-align: center;
    }
    .user-info:hover {
      cursor: pointer;
    }
    .log-out{
      position:absolute;
      right:10px;

    }
  }
}

</style>
